// extracted by mini-css-extract-plugin
module.exports = {"kitProduct":"Product_kitProduct__0hiY_"};